import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO23 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK002-3.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO23
